import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

/**
 * ONE BUTTON THAT SWITCHES BETWEEN ENGLISH AND SPANISH.
 *
 * The label is written in the language the click would switch TO - "Español" for an English
 * reader, "English" for a Spanish one - because the person who needs the button is precisely the
 * one who cannot read the current language. The title/aria-label say the same in the CURRENT
 * language for screen readers.
 *
 * `tone`: 'dark' for the sidebar and login page (light text on navy), 'light' for a white page.
 */
export default function LanguageToggle({ tone = 'dark', className = '', iconOnly = false }) {
  const { lang, setLang, t } = useLanguage();
  const next = lang === 'es' ? 'en' : 'es';
  const nextLabel = next === 'es' ? 'Español' : 'English';
  const help = next === 'es' ? t('View in Spanish') : t('View in English');

  const colors =
    tone === 'dark'
      ? 'text-[#aeb0b6] hover:text-white hover:bg-white/5'
      : 'text-[#64748b] hover:text-[#0f172a] hover:bg-[#f1f5f9]';

  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      title={help}
      aria-label={help}
      data-testid="language-toggle"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-[8px] text-xs font-medium transition-colors ${colors} ${className}`}
    >
      <span className="material-symbols-outlined text-[18px]" aria-hidden="true">
        language
      </span>
      <span className={iconOnly ? 'sr-only' : undefined}>{nextLabel}</span>
    </button>
  );
}
